import {z} from 'zod';

export const DISCORD_CALLBACK_PATH = '/api/account/discord/callback';
export const DiscordConfigurationSchema = z.object({
  clientSecretFile: z.string().regex(/^\/[A-Za-z0-9_./-]+$/)
}).strict();
export const DiscordStatusSchema = z.object({
  signInLinked: z.boolean(), username: z.string().nullable()
}).strict();
export type DiscordStatus = z.infer<typeof DiscordStatusSchema>;
export type DiscordIdentity = {id: string; username: string; email: string};
